import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';
import { featureFlag } from '../../featureFlags';

function ToggleORConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_OR_EXPANSION_ENABLED)
    ? {
        autoDiscounts: [
          AUTO_DISCOUNTS.distantStudent,
          AUTO_DISCOUNTS.goodStudent,
          AUTO_DISCOUNTS.homeowner,
          AUTO_DISCOUNTS.multiCar,
          AUTO_DISCOUNTS.multiPolicy,
          AUTO_DISCOUNTS.safeDriving,
          AUTO_DISCOUNTS.teenDriver,
        ],
        visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
          return {
            ...visibleCoverages,
            protectionCoverages: [
              ...visibleCoverages.protectionCoverages,
              {
                label: 'Underinsured Motorist Bodily Injury',
                key: 'underinsured_motorist_bodily_injury_limit',
              },
              {
                label: 'Pet Passenger',
                key: 'pet_passenger',
              },
            ],
            vehicleCoverages: [
              ...visibleCoverages.vehicleCoverages,
              {
                label: 'Uninsured Motorist Property Damage',
                key: 'uninsured_motorist_property_damage_limit',
              },
            ],
          };
        },
        initialCoverageValues: {
          gap: 'false',
          temporary_ride: 'null',
          side_hustle: 'false',
          uninsured_motorist_property_damage_limit: '0',
        },
      }
    : {};
}
export default ToggleORConfig;
